import React from "react";
import Classes from "classnames";

import FormFieldFormElementProto from "../../form-element-proto";
import Date from 'core/gd-form/form-element/datepicker/datepicker-new';

class StringField extends FormFieldFormElementProto {

    constructor(props) {
        super(props);

        // this._bind('onFocus','onBlur','onChange');
        //
        // this.state = {
        //     isEditing: false,
        //     value: this.props.value
        // }

    }

    onChange(newValue) {

        if (!newValue) newValue = '';

        const { onChange } = this.props;
        this.setState({value: newValue}, ()=>{
            if (onChange) onChange(newValue)
        });
    }

    // onFocus(e) {
    //     this.setState({isEditing: true}, ()=> {
    //         if (this.props.onFocus) this.props.onFocus(e)
    //     });
    // }
    //
    // onBlur(e) {
    //     this.setState({isEditing: false}, ()=>{
    //         if (this.props.onBlur) this.props.onBlur(e);
    //     });
    // }

    render() {

        let classes;

        classes = Classes('gd-form-field-date','form-element',{
        });

        return (

            <div className={classes}>
                <Date size="big" form={this.props.form} name={this.props.name} />
            </div>

        );
    }

}

// StringField.propTypes = props;
// StringField.defaultProps = defaultProps;

export default function renderStringFormFieldFormElement(field, props) {
    return <StringField field={field} {...props} />;
}